import { NgModule } from '@angular/core';
import { UIFlowchartComponent } from './task-flowchart/task-flowchart.component';
import { CommonModule } from '@angular/common';
import { HttpService } from '@ecp-caf/caf-common';
import { UiFlowchartService } from './services/ui-flowchart.service';
import { WFFlowchartService } from './wf-flowchart.service';
import { MessagerModule } from '@farris/ui-messager';
import { FarrisDialogModule } from '@farris/ui-dialog';
import { TranslatePipe } from './services/translate.pipe';
import { LayoutModule } from '@farris/ui-layout';
import { FarrisSectionModule } from '@farris/ui-section';
import { WfApprovalLogsModule } from '@gsp-wf/wf-approval-logs';
import { ComboListModule } from '@farris/ui-combo-list';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FDropdownDirectiveTypeModule } from '@farris/ui-dropdown';
import { DatagridModule } from '@farris/ui-datagrid';
import { NotifyModule } from '@farris/ui-notify';
import { LoadingModule } from '@farris/ui-loading';
import { FarrisTabsModule } from '@farris/ui-tabs';
import { SplitterModule } from '@farris/ui-splitter';

@NgModule({
  declarations: [
    UIFlowchartComponent,
    TranslatePipe],
  imports: [
    LayoutModule,
    CommonModule,
    FarrisDialogModule,
    MessagerModule.forRoot({
      width: 500
    }),
    FarrisSectionModule,
    WfApprovalLogsModule,
    ComboListModule,
    ReactiveFormsModule,
    FormsModule,
    FDropdownDirectiveTypeModule,
    DatagridModule,
    NotifyModule,
    LoadingModule,
    FarrisTabsModule.forRoot(),
    SplitterModule
  ],
  exports: [UIFlowchartComponent],
  providers: [
    HttpService,
    UiFlowchartService,
    WFFlowchartService,
  ],
  entryComponents: [
    UIFlowchartComponent
  ]
})
export class UiFlowchartModule { }
